import React, { Component } from "react";
import {Modal, Card, Form, Button, Row, Col, Table, Alert, Tab, Tabs, InputGroup, OverlayTrigger, Tooltip, ListGroup, FormLabel, CardBody} from "react-bootstrap";
import api from "../../services/api";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { categoriasDeDicas } from '../../common/utils';
import Paginacao from '../../common/pagination';
import { FaEdit, FaTrash } from "react-icons/fa";
import '../ProgramasV2/ProgramasEdit.module.css';

class DicasPrograma extends Component {
    constructor(props) {
        super(props);
        this.state = {
            dicas: [],
            dicaSelecionada: [{ titulo: '', imagem: '', imagem_upload: '', descricao: '', categoria: '', id: null }],
            programa_id: this.props.programa_id,
            erroLoadRegistro: '',
            loading: false,
            page_numb: this.props.page_numb || 1,
            page_limit: this.props.page_limit || 10
        }
    }

    componentDidMount() {
        this.carregarDicas();
    }

    carregarDicas = async () => {
        if (this.state.programa_id) {
            await api.get(`/programas/dicas/?programa_id=${this.state.programa_id}&page=${this.state.page_numb}&page_limit=${this.state.page_limit}`)
            .then(response => {
                this.setState({
                    dicas: {
                        ...response.data,
                        results:response.data.results.map(dica => ({
                            id: dica.id,
                            titulo: dica.titulo,
                            imagem: dica.imagem,
                            descricao: dica.descricao,
                            categoria: dica.categoria,
                        }))
                    }
                });
            })
            .catch(error => {
                console.error('Erro ao carregar dicas:', error);
                
                let erro_msg = 'Erro ao carregar dicas do programa, tente novamente';

                if(error.response && error.response.status === 500){
                    erro_msg = 'Servidor indisponível no momento, tente novamente';
                }

                this.setState({
                    erroLoadRegistro: erro_msg,
                })
            });
        }
    }

    handleDicasChange = (e, fieldName) => {
        if (fieldName === 'imagem_upload') {
            this.setState({ dicaSelecionada: { ...this.state.dicaSelecionada, imagem_upload: e.target.files[0] } });
        }
        else {
            const { name, value } = e.target;
            this.setState({ dicaSelecionada: { ...this.state.dicaSelecionada, [name]: value } });
        }
    }

    handleSalvarDica = async () => {
        const formData = new FormData();
        const url = this.state.dicaSelecionada.id ? `/programas/dicas/${this.state.dicaSelecionada.id}/` : '/programas/dicas/';
        const metodo = this.state.dicaSelecionada.id ? 'put' : 'post';
    
        if (this.state.dicaSelecionada.imagem_upload) {
            formData.append('imagem', this.state.dicaSelecionada.imagem_upload);
        }        

        formData.append('titulo', this.state.dicaSelecionada.titulo);
        formData.append('categoria', this.state.dicaSelecionada.categoria);
        formData.append('descricao', this.state.dicaSelecionada.descricao);
        formData.append('programa_id', this.state.programa_id); 
        
        api({
            method: metodo,
            url: url,
            data: formData,
        })
        .then(response => {
            
            const MySwal = withReactContent(Swal)
            const textSwal = (this.state.dicaSelecionada.id) ? 'Dica atualizada com sucesso' : 'Dica cadastrada com sucesso';

            MySwal.fire({
                title: <p>{textSwal}</p>,
                icon: 'success',
                showCloseButton: true,
            })

            this.carregarDicas();
            this.handleCloseModalDicas();
            
        })
        .catch(error => {
            let erro_msg = 'Erro ao cadastrar a dica, verifique os campos e tente novamente';         
            let content = '';   

            if(error.response && error.response.status === 500){
                erro_msg = 'Servidor indisponível no momento';
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];

                    if(key == 'titulo') {
                        content += `<br>&bull; Título: ${value}`;
                    }
                    if(key == 'descricao') {
                        content += `<br>&bull; Descrição: ${value}`;
                    }
                }
            }

            const MySwal = withReactContent(Swal)
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{erro_msg}</p>,
                html: content,
            })
        });
    }

    removerDica = (dica) => {
        const MySwal = withReactContent(Swal);
    
        MySwal.fire({
            title: 'Remover dica?',
            text: "Tem certeza que deseja remover a dica " + dica.titulo + "?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Sim, remover!',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.isConfirmed) {
                if (dica.id) {
                    api({
                        method: 'delete',
                        url: `/programas/dicas/${dica.id}/`,
                    })
                    .then(response => {
                                              
                        const MySwal = withReactContent(Swal)
                        const textSwal = 'Dica removida com sucesso';

                        MySwal.fire({
                            title: <p>{textSwal}</p>,
                            icon: 'success',
                            showCloseButton: true,
                        })

                        this.carregarDicas();
                    })
                    .catch(error => {
                        let erro_msg = 'Erro ao remover a dica, tente novamente';            

                        if(error.response && error.response.status === 500){
                            erro_msg = 'Servidor indisponível no momento';
                        }
                        else if(error.response && error.response.status === 400){
                            const campos = error.response.data;       
                            
                        }

                        const MySwal = withReactContent(Swal)
                        MySwal.fire({
                            icon: 'error',
                            showCloseButton: true,
                            title: <p>{erro_msg}</p>,
                        })
                    });

                } else {
                    this.setState(prevState => ({
                        dicas: prevState.dicas.filter((_, i) => i !== index),
                    }));
        
                    MySwal.fire(
                        'Removido!',
                        'A dica foi removida.',
                        'success'
                    );
                }
            }
        });
    };

    handleShowModalDicas = (dica = []) => {
        this.setState({ showModalDicas: true, dicaSelecionada: dica });
    }

    handleCloseModalDicas = () => {
        this.setState({ showModalDicas: false, dicaSelecionada: []});
    }

    onClickPaginaDicas = (num_page) => {
        this.setState({
            loading: true,
            page_numb: num_page
        }, () => {
            this.carregarDicas(num_page)
        });
    };


    render() {
        return (
            <>
            <Card className="cardDestaque mt-4">
                <Card.Body>                   
                    <Row className="align-items-center mb-3">
                        <Col sm={6} lg={6}>
                            <h6><strong>Dicas do Programa</strong></h6>
                        </Col>
                        <Col sm={6} xs={6} className="text-end">                       
                            <Button type="button" variant="success" className="btn-sm mt-3" disabled={this.state.loading} onClick={() => this.handleShowModalDicas()}>
                                {this.state.loading ? <span className="spinner-border spinner-border-sm"></span> : 'Adicionar Dica'}                                       
                            </Button>
                        </Col>
                    </Row>
                    {('results' in this.state.dicas && this.state.dicas.results.length > 0) ? (
                        <Row>
                            <Col sm={12} lg={12}>
                                <Table responsive className="custom-table">
                                    <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Título</th>
                                            <th>Descrição</th>
                                            <th>Categoria</th>
                                            <th>Opções</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.dicas.results.map((dica, index) => ( 
                                            <tr key={index}>
                                                <td className="bg-id">#{dica.id}</td>
                                                <td className="td-border">{dica.titulo}</td>
                                                <td className="td-border">{dica.descricao}</td>
                                                <td className="td-border">{categoriasDeDicas[dica.categoria]}</td>
                                                <td>
                                                    <Button variant="secondary" size="sm" className="me-2" onClick={() => this.handleShowModalDicas(dica)}>
                                                        <FaEdit /> Editar
                                                    </Button>  
                                                    <Button variant="danger" size="sm" className="me-2" onClick={() => this.removerDica(dica)}>
                                                        <FaTrash /> Remover
                                                    </Button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                                    {'results' in this.state.dicas && this.state.dicas.results.length > 0 && (
                                        <Paginacao dados={this.state.dicas} limit={this.state.page_limit} loading={this.state.loading} page_numb={this.state.page_numb} _onClickPagina={this.onClickPaginaDicas} />
                                    )}
                            </Col>
                        </Row>   
                    ) : (
                        <p>Nenhuma dica cadastrada até o momento</p>
                    )}
                            
                </Card.Body>                
            </Card>

            <Modal show={this.state.showModalDicas} onHide={this.handleCloseModalDicas} size="xl">
                <Modal.Header closeButton>
                    <Modal.Title>
                        {this.state.dicaSelecionada.id ? 'Editar Dica #' + this.state.dicaSelecionada.id : 'Adicionar Dica'}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <h4>Dicas</h4>
                            <div className="row-list">
                                <Row>
                                    <Col sm={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Título</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="titulo"
                                                value={this.state.dicaSelecionada.titulo} 
                                                onChange={e => this.handleDicasChange(e, 'titulo')}
                                            />
                                        </Form.Group>
                                    </Col>                                                    
                                    <Col sm={6}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Imagem</Form.Label>
                                            <Form.Control 
                                                type="file" 
                                                name="imagem" 
                                                onChange={e => this.handleDicasChange(e, 'imagem_upload')}
                                                ref={this.fileInput} 
                                            />
                                            {this.state.dicaSelecionada.imagem && (
                                                <div>
                                                    <img src={this.state.dicaSelecionada.imagem} alt="Imagem Atual" style={{ maxWidth: '100px', marginTop: '10px' }} />
                                                </div>
                                            )}
                                        </Form.Group>
                                    </Col>
                                    <Col sm={4} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Categoria</Form.Label>
                                            <Form.Control as="select" name="categoria" value={this.state.dicaSelecionada.categoria} onChange={e => this.handleDicasChange(e, 'categoria')}>
                                                <option value="">Categoria da Dica</option>
                                                {Object.entries(categoriasDeDicas).map(([sigla, nome]) => (
                                                    <option key={sigla} value={sigla}>{nome}</option>
                                                ))}
                                            </Form.Control>
                                            <Form.Text id="formCategoriaHelpBlock" className="text-danger">{this.state.categoriaHelper}</Form.Text>
                                        </Form.Group>
                                    </Col>
                                    <Col sm={12} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Descrição <span style={{ color: 'red' }}> *</span></Form.Label>
                                            <Form.Control 
                                                as="textarea" 
                                                required 
                                                placeholder="Descrição" 
                                                name="descricao"
                                                value={this.state.dicaSelecionada.descricao} 
                                                onChange={e => this.handleDicasChange(e, 'descricao')}
                                                rows={3}
                                            />
                                        </Form.Group>
                                    </Col>
                                </Row>
                            </div>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={this.handleCloseModalDicas}>
                        Fechar
                    </Button>
                    <Button variant="primary" onClick={this.handleSalvarDica}>
                        Salvar
                    </Button>
                </Modal.Footer>
            </Modal>
            </>
        );
    }
}

export default DicasPrograma;

